<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import { useContent } from '@/domains/investor/composables/useContent'
import Content from '@/domains/investor/components/Content/Content.vue'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorCharteredAuditor.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorCharteredAuditor.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorCharteredAuditor.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorCharteredAuditor.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorCharteredAuditor.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorCharteredAuditor.canonical.pl'),
    },
  ],
}))

const { getContent } = await useContent()
const charteredAuditorSection = await getContent('biegly-rewident')

</script>

<template>
  <div>
    <InvestorHero
      :title="$t('investor.charteredAuditor.hero.title')"
      :lead="$t('investor.charteredAuditor.hero.lead')"
      image="/images/investor/hero/chartered-auditor.png"
      :first-button="{
        text: $t('investor.charteredAuditor.hero.firstButton.label'),
        to: $t('investor.charteredAuditor.hero.firstButton.to'),
      }"
    />

    <UiSection
      :id="$t('investor.charteredAuditor.sectionId')"
      class="chartered-auditor__section"
      color="white"
    >
      <UiHeader
        :header="$t('investor.charteredAuditor.hero.title')"
        :position="'center'"
        :header-size="'h5'"
        header-size-tablet="h5"
        header-size-mobile="h5"
      />

      <Content :content="charteredAuditorSection.data.value?.content" />

    </UiSection>
  </div>
</template>
